import { VITE_LEAD_AGENT_CONFIG_V2 } from 'src/constants/envs';
import type { tLeadAgentDashboardAudience } from 'src/constants/leadAgentDashboard';
import { sentry } from 'src/sentry/sentry.singleton';

export class InvalidDashboardAudienceError extends Error {
  constructor(raw: string) {
    super(`VITE_LEAD_AGENT_CONFIG_V2 must be empty, all, true, false or a comma-separated WID list; got "${raw}". Every workspace sees the current dashboard.`);
    this.name = 'InvalidDashboardAudienceError';
  }
}

export function reportInvalidAudience(audience: tLeadAgentDashboardAudience, report: (error: Error) => void): void {
  if (audience.kind === 'invalid') report(new InvalidDashboardAudienceError(audience.raw));
}

reportInvalidAudience(VITE_LEAD_AGENT_CONFIG_V2, (error) => sentry.captureException(error));

export const LEAD_AGENT_DASHBOARD_AUDIENCE: tLeadAgentDashboardAudience = VITE_LEAD_AGENT_CONFIG_V2;
